import React, { useRef } from 'react';
import { Printer } from 'lucide-react';
interface GatePassReceiptProps {
  gatepassNumber: string;
  vehicleNumber: string;
  vehicleType: string;
  entryTime: string;
  operatorName: string;
  onClose: () => void;
}
export function GatePassReceipt({
  gatepassNumber,
  vehicleNumber,
  vehicleType,
  entryTime,
  operatorName,
  onClose
}: GatePassReceiptProps) {
  const receiptRef = useRef<HTMLDivElement>(null);
  const handlePrint = () => {
    window.print();
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 print:bg-white print:p-0" data-id="element-69">
      {/* Action buttons - hidden on print */}
      <div className="absolute top-4 right-4 flex gap-2 print:hidden" data-id="element-70">
        <button onClick={handlePrint} className="flex items-center gap-2 bg-brand-teal text-white px-4 py-2.5 rounded-xl font-medium text-sm hover:bg-brand-tealHover transition-colors min-h-[48px]" data-id="element-71">
          <Printer className="w-4 h-4" data-id="element-72" />
          Print
        </button>
        <button onClick={onClose} className="bg-white text-slate-700 px-4 py-2.5 rounded-xl font-medium text-sm hover:bg-slate-100 transition-colors min-h-[48px] border border-slate-200" data-id="element-73">
          Close
        </button>
      </div>

      {/* Receipt */}
      <div ref={receiptRef} id="print-receipt" className="bg-white w-[302px] font-mono text-[11px] leading-[1.4] text-black p-4 shadow-2xl print:shadow-none print:w-[80mm] print:p-[4mm]" data-id="element-74">
        {/* Company Header */}
        <div className="text-center mb-1" data-id="element-75">
          <div className="text-[15px] font-bold tracking-wide" data-id="element-76">ERPLogiPark</div>
          <div className="text-[9px] leading-tight mt-0.5 text-gray-700" data-id="element-77">
            Terminal Management &amp; Gate Automation
          </div>
        </div>

        {/* Address */}
        <div className="text-center text-[9px] leading-tight text-gray-600 mb-2" data-id="element-78">
          Plot No. 45, Logistics Hub, Sector 18
          <br data-id="element-79" />
          Industrial Area, Bangalore - 560100
          <br data-id="element-80" />
          Ph: +91 80 4567 8900
        </div>

        {/* Separator */}
        <div className="border-t border-dashed border-gray-400 my-2" data-id="element-81" />

        {/* Title */}
        <div className="text-center font-bold text-[13px] tracking-wider mb-1" data-id="element-82">
          GATE PASS
        </div>

        {/* Separator */}
        <div className="border-t border-dashed border-gray-400 my-2" data-id="element-83" />

        {/* Details */}
        <div className="space-y-[6px]" data-id="element-84">
          <div className="flex justify-between" data-id="element-85">
            <span className="text-gray-500" data-id="element-86">GP No:</span>
            <span className="font-bold" data-id="element-87">{gatepassNumber}</span>
          </div>
          <div className="flex justify-between" data-id="element-88">
            <span className="text-gray-500" data-id="element-89">Date/Time:</span>
            <span data-id="element-90">{entryTime}</span>
          </div>

          <div className="border-t border-dotted border-gray-300 my-1" data-id="element-91" />

          <div className="flex justify-between" data-id="element-92">
            <span className="text-gray-500" data-id="element-93">Vehicle No:</span>
            <span className="font-bold text-[12px]" data-id="element-94">{vehicleNumber}</span>
          </div>
          <div className="flex justify-between" data-id="element-95">
            <span className="text-gray-500" data-id="element-96">Vehicle Type:</span>
            <span data-id="element-97">{vehicleType}</span>
          </div>

          <div className="border-t border-dotted border-gray-300 my-1" data-id="element-98" />

          <div className="flex justify-between" data-id="element-99">
            <span className="text-gray-500" data-id="element-100">Operator:</span>
            <span data-id="element-101">{operatorName}</span>
          </div>
        </div>

        {/* Separator */}
        <div className="border-t border-dashed border-gray-400 my-3" data-id="element-102" />

        {/* Signature Area */}
        <div className="flex justify-between mt-4 mb-2 px-1" data-id="element-103">
          <div className="text-center" data-id="element-104">
            <div className="border-t border-gray-400 w-20 mb-1 mt-6" data-id="element-105" />
            <div className="text-[8px] text-gray-500" data-id="element-106">Security</div>
          </div>
          <div className="text-center" data-id="element-107">
            <div className="border-t border-gray-400 w-20 mb-1 mt-6" data-id="element-108" />
            <div className="text-[8px] text-gray-500" data-id="element-109">Driver</div>
          </div>
        </div>

        {/* Separator */}
        <div className="border-t border-dashed border-gray-400 my-2" data-id="element-110" />

        {/* Footer */}
        <div className="text-center text-[8px] text-gray-500 leading-tight" data-id="element-111">
          <div data-id="element-112">This is a system generated gate pass.</div>
          <div data-id="element-113">Please keep this slip until exit.</div>
          <div className="mt-1" data-id="element-114">© 2026 ERPLogiPark</div>
        </div>

        {/* Cut line indicator */}
        <div className="border-t border-dashed border-gray-300 mt-3 mb-1" data-id="element-115" />
        <div className="text-center text-[7px] text-gray-300" data-id="element-116">✂ CUT HERE</div>
      </div>
    </div>;
}